import { useQuery } from "@tanstack/react-query";

import { apiFetch, buildParams } from "@/lib/api";
import { homeQueryKeys } from "@/lib/homeQueryCache";
import type { AviDeadlineOutput } from "@/types";

type Params = {
  account_id: string;
  role: string;
};

export function useDeadlineAvi(params: Params, enabled = true) {
  const query = buildParams(params);

  return useQuery({
    queryKey: [...homeQueryKeys.aviDeadline, params],
    queryFn: () => apiFetch<AviDeadlineOutput>(`/v1/home/avi-deadline${query}`),
    enabled,
  });
}
